import React, { Component } from "react";
import { apiFetch } from "apiFetch";
import { toast } from "react-toastify";
import PaymentDocumentLayout from "home/components/payment-document-layout";

let errorMessage = "An error occured, please try again later";

class PaymentDocuments extends Component {
  state = {
    pdfDocument: null,
    numPages: 1,
    pageNumber: 1
  };

  componentDidMount() {
    const paymentId = this.props.currentPlan.paymentId;

    apiFetch(`/api/paymentDetails/${paymentId}/document`, {
      method: "GET",
      rawResponse: true
    })
    .then(resp => {
      if (resp.ok) {
        return resp.arrayBuffer()
      }
      throw new Error();
    })
    .then(data => {
      this.pdfBlob = new Blob([data], {type: 'application/pdf'});
      const int8Document = new Int8Array(data);
      this.setState({
        pdfDocument: int8Document
      });
    })
    .catch(() => {
      toast.error(errorMessage);
    })
  }

  componentWillUnmount() {
    this.pdfBlob = null;
  }

  onDownloadPressed = () => {
    if (this.pdfBlob) {
      let objectUrl = URL.createObjectURL(this.pdfBlob);
      const link = document.createElement('a');
      link.href = objectUrl;
      link.download = `Account_Documents_${new Date()}.pdf`;
      link.click();
      objectUrl = null;
    }
  }

  onDocumentLoad = ({ numPages }) => {
    this.setState({ numPages });
  };

  handlePageNumber = page => {
    this.setState({
      pageNumber: this.state.pageNumber + page
    });
  };

  render() {
    return this.state.pdfDocument ? (
      <PaymentDocumentLayout
        {...this.state}
        onDownloadPressed={this.onDownloadPressed}
        onLoadSuccess={this.onDocumentLoad}
        handlePageNumber={this.handlePageNumber}
        handleShow={this.props.handleShow}
      />
    ) : null;
  }
}

export default PaymentDocuments;



// WEBPACK FOOTER //
// ./src/home/containers/payment-documents.js